import { useFormContext } from 'react-hook-form';
import { Button, Highlight, Stack } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { EnterpriseBuilderParametersType } from '@mews-commander/data-access';
import { Empty, Loader } from '@mews-commander/ui';
import { TreeField } from '@mews-commander/form';
import { useGetDependencyMappings } from '../../../queries/useGetDependencyMappings';
import { createAdapter, transformDependencies } from '../../../utils';
import { EnterpriseBuilderProFormFieldNames, EnterpriseBuilderProFormValues } from '../formMapping';

interface ExportSettingsStepProps {
    propertyType: EnterpriseBuilderParametersType;
    onSubmit: () => void;
}

export const ExportSettingsStep = ({ propertyType, onSubmit }: ExportSettingsStepProps) => {
    const { data, isLoading } = useGetDependencyMappings(propertyType);
    const { watch } = useFormContext<EnterpriseBuilderProFormValues>();
    const selectedEntities = watch(EnterpriseBuilderProFormFieldNames.ExportSettings) ?? [];

    if (isLoading) {
        return <Loader />;
    }

    if (!data) {
        return <Empty />;
    }

    return (
        <Stack vertical spacing="100">
            <Stack vertical spacing="100">
                <Highlight size="medium">{lt('EnterpriseBuilderProExportSettings')}</Highlight>
            </Stack>
            <TreeField
                name={EnterpriseBuilderProFormFieldNames.ExportSettings}
                multiple
                options={transformDependencies(
                    data,
                    propertyType === EnterpriseBuilderParametersType.ExistingEnterprise
                )}
                defaultExpandAll
                transform={createAdapter(data, selectedEntities)}
            />
            <Stack alignment="end">
                <Button variant="primary" onClick={onSubmit} type="submit">
                    {lt('StartExport')}
                </Button>
            </Stack>
        </Stack>
    );
};
